import React from "react";
import volcano from "./logovolcano.png";
import "./header.css";
import Typical from "react-typical";
import Aos from "aos";
import "aos/dist/aos.css";

function Header() {
  React.useEffect(() => {
    Aos.init();
  }, []);
  return (
    <div className="header">
      <div className="container">
        <div className="row" id="#" data-aos="zoom-in" data-aos-duration="1500">
          <div className="col-2">
            <h1>
              Bienvenue chez nous ! <br />
              Le meilleur kebab au Mans? C'est chez Volcano que ça se passe!{" "}
            </h1>
            <br />
            <h2 style={{ color: "white" }}>
              {" "}
              <Typical
                loop={Infinity}
                wrapper="b"
                steps={[
                  "La Qualité 💯🌋 ",
                  1500,
                  "Le gout ♨️🌋",
                  1500,
                  "Hygiéne ❤️🌋 ",
                  1500,
                  "L'Acceuil ❤️‍🔥🌋  ",
                  1500,
                ]}
              />{" "}
            </h2>

            <button className="btn ">
              <a href="#menu">Voir le menu</a>
            </button>
          </div>

          <div className="col-2">
            <img className="card-action" src={volcano} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;
